import React from 'react';
import PropTypes from 'prop-types';
import { cn } from 'lib/utils';

export default function ContentLibraryFilterSelect({
  label,
  value,
  onChange,
  children,
  disabled,
  className
}) {
  return (
    <div
      className={cn(
        'relative w-full min-w-0',
        disabled && 'opacity-60',
        className
      )}
    >
      <label className='pointer-events-none absolute left-3 top-0 z-1 -translate-y-1/2 bg-white px-1 text-xs font-medium text-gray-600'>
        {label}
      </label>
      <select
        className='box-border min-h-11 w-full appearance-none rounded border border-gray-400 bg-white px-3 py-2.5 pr-10 text-sm text-gray-900 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 disabled:bg-gray-50'
        value={value}
        onChange={e => onChange(e.target.value)}
        disabled={disabled}
      >
        {children}
      </select>
      <span className='pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 text-gray-500'>
        <svg
          width='20'
          height='20'
          viewBox='0 0 24 24'
          fill='none'
          stroke='currentColor'
          strokeWidth='2'
          aria-hidden
        >
          <path d='M6 9l6 6 6-6' />
        </svg>
      </span>
    </div>
  );
}

ContentLibraryFilterSelect.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string
};

ContentLibraryFilterSelect.defaultProps = {
  disabled: false
};
